import {
  AtsFeedbackDetailFragment,
  GetAtsFeedbacksDocument,
  UpdateAtsFeedbackDocument,
  UpdateAtsFeedbackMutation,
  UpdateAtsFeedbackMutationVariables,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

type Variables = Omit<UpdateAtsFeedbackMutationVariables, 'id'>

export const useUpdateFeedback = (feedback: AtsFeedbackDetailFragment) => {
  const [updateAtsFeedbackMutation, { loading }] = useMutation(UpdateAtsFeedbackDocument, {
    extractorFn: (data: UpdateAtsFeedbackMutation) => data.atsMutations.updateAtsFeedback,
  })

  return {
    loading,
    updateFeedback(variables: Variables) {
      return updateAtsFeedbackMutation({
        variables: { id: feedback.id, ...variables },
        refetchQueries: [GetAtsFeedbacksDocument],
      })
    },
  }
}
